module.exports = __webpack_public_path__ + "media/images/lb/008-df2ef71f6e5b3ef9206234bfebb5c083.svg";